<template>
  <div>
    <div class="query_wapper">
      <div class="query_item">
        <el-select :popper-append-to-body="false" style="width:200px" placeholder="按注册项目查看" clearable v-model="query.project">
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select :popper-append-to-body="false" style="width:200px" clearable placeholder="按职称查看" v-model="query.positional">
          <el-option label="初级职称" :value="1"></el-option>
          <el-option label="中级职称" :value="2"></el-option>
          <el-option label="副教授（高级教练）" :value="3"></el-option>
          <el-option label="教授（国家级教练）" :value="4"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select :popper-append-to-body="false" style="width:200px" clearable placeholder="按性别查看" v-model="query.gender">
          <el-option label="全部" :value="'all'"></el-option>
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="warning" @click="print" v-if="false">打印</el-button>
      </div>
    </div>
    <printTable ref="print_table" :printColumns="printColumns" :printTableData="printTableData"></printTable>
    <el-table border style="width:100%;margin-top:20px" :data="tableData">
      <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名"></el-table-column>
      <el-table-column align="center" label="性别">
        <template slot-scope="scope">
          <span>{{!scope.row.gender?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="political" align="center" label="政治面貌">
        <template slot-scope="scope">
          <span>{{scope.row.political === 1?'团员':scope.row.political === 2?'党员':scope.row.political === 3?'民主党派':'群众'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="出生年月">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.birthday,'slash')}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="职称">
        <template slot-scope="scope">
          <span>{{getPositional(scope.row.positional)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首注项目">
        <template slot-scope="scope">
          <span>{{screenProject(scope.row.projectFirst)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="registerNumber" align="center" label="注册号"></el-table-column>
      <el-table-column prop="phone" align="center" label="移动电话"></el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            :style="{color:screenStatus(scope.row.state).color}"
          >{{screenStatus(scope.row.state).label}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="operation(scope.row.id,'watch')">查看</el-button>
          <el-button type="text" size="small" @click="operation(scope.row.id,'update')">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeDialog"
      :close-on-click-modal="false"
      top="50px"
      :visible.sync="centerDialogVisible"
      :title="title"
      width="1200px"
    >
      <updateRegistrationPage @clearUpdate="clearUpdate" :updateObj="updateObj"></updateRegistrationPage>
    </el-dialog>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
import printTable from "@/components/print-table";
import updateRegistrationPage from "./component/update-registration-page";
import { page, formatPrintTableData, table } from "@/common/js/mixins";
import { getCoachList } from "@/api/coach";
import { method } from "@/utils/utils";
export default {
  mixins: [page, formatPrintTableData, table],
  components: {
    printTable,
    updateRegistrationPage
  },
  data() {
    return {
      query: {
        project: "",
        positional: "",
        gender: "",
        keyword: ""
      },
      updateObj: {
        id: "",
        type: ""
      },
      title: "",
      stateList: [
        {
          label: "草稿",
          value: 0,
          color: "rgb(64, 142, 232)"
        },
        {
          label: "学校待审核",
          value: 1,
          color: "rgb(64, 142, 232)"
        },
        { label: "学校未通过", value: 2, color: "rgb(252, 91, 91)" },
        { label: "分会待审核", value: 3, color: "rgb(64, 142, 232)" },
        { label: "分会未通过", value: 4, color: "rgb(252, 91, 91)" },
        { label: "分会通过", value: 5, color: "rgb(51, 204, 154)" }
      ],
      centerDialogVisible: false,
      printColumns: [
        {
          title: "序号",
          key: "index"
        },
        {
          title: "姓名"
        }
      ]
    };
  },
  computed: {
    // 筛选项目
    screenProject() {
      return data => {
        let label = "";
        this.projectList.filter(item => {
          if (data === item.value) label = item.label;
        });
        return label;
      };
    },
    // 状态筛选
    screenStatus() {
      return data => {
        let status = {};
        this.stateList.filter(item => {
          if (data === item.value) status = item;
        });
        return status;
      };
    },
    // 获取职称筛选
    getPositional() {
      return data => {
        let str = "";
        switch (data) {
          case 1: {
            str = "初级职称";
            break;
          }
          case 2: {
            str = "中级职称";
            break;
          }
          case 3: {
            str = "副教授（高级教练）";
            break;
          }
          case 4: {
            str = "教授（国家级教练）";
            break;
          }
        }
        return str;
      };
    },
    // 获取项目列表
    projectList() {
      return [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
    },
    // 格式化时间
    formatTime() {
      return (data, type = null) => {
        return method.timeFormat(data, type);
      };
    }
  },
  methods: {
    // 查看/编辑页面返回
    clearUpdate() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.centerDialogVisible = false;
      this.getList();
    },
    // 关闭弹窗
    closeDialog() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
    },
    // 查看/修改 打开弹窗
    operation(id, type) {
      Object.assign(this.updateObj, {
        id,
        type
      });
      this.title = type === "watch" ? "注册信息查看" : "注册信息修改";
      this.centerDialogVisible = true;
    },
    // 查询
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 获取打印数据列表
    async print() {
      //   let { list } = await;
      this.getPrintData(list);
    },
    // 获取列表
    getList() {
      getCoachList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gender: this.query.gender == "all" ? "" : this.query.gender
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.query_wapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .query_item {
    margin: 0 20px 20px 0;
  }
  .search_btn {
    background-color: #2db78a !important;
    border-color: #2db78a !important;
    color: #fff;
    border-radius: 0 4px 4px 0;
    width: 90px;
  }
}
</style>